import DialogController from './ui/dialog_controller';

export default class extends DialogController {
  static targets = ['name'];
  #onConfirm = null;

  open({ sectionName, onConfirm }) {
    this.nameTarget.textContent = sectionName;
    this.#onConfirm = onConfirm;
    this.element.showModal();
  }

  confirm() {
    this.close();
    this.#onConfirm?.();
    this.#onConfirm = null;
  }
}
